import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import back from "../../assets/svg/backArrow.svg";
import uploadImage from "../../assets/svg/uploadImage.svg";
import "../common/Util.css";
import "./CreateProduct.css";
import { X, MoveLeft } from "lucide-react";
import CommonDropdown from "../common/common_dropDown";
import Dropdown from "react-bootstrap/Dropdown";
import dropDown from "../../assets/svg/dropDown.svg";
import AsyncSelect from "react-select/async";
import { apiCall } from "../../services/api-service";
import CommonStaticDropdown from "../common/common_static_dropdown";
import ErrorExtractor from "../common/error_extractor";
import DOMPurify from "dompurify";
import {
  getProductEditApi,
  saveAttachmentApi,
  submitProductAPI,
  updateProductAPI,
} from "./productApi";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner, Toast, ToastContainer } from "react-bootstrap";

const multiselectCustomStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "0.7px solid #E5E5E5",
    padding: "2px",
    fontWeight: "500",
    fontSize: "13px",
    color: "#212129",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#007bff"
      : state.isFocused
        ? "#e0e0e0"
        : "#fff",
    color: state.isSelected ? "#fff" : "#333",
    padding: 10,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#F6F7F8",
    color: "#212129",
    borderRadius: "5px",
    padding: "2px 5px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#212129",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#212129",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const selectUnitOption = [
  { label: "CM", value: "cm" },
  { label: "Inch", value: "inch" },
  { label: "M", value: "m" },
  { label: "MM", value: "mm" },
];

export const CreateProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from;
  const vendorFromNav = location.state || null;
  const { id } = location.state || {};
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const fileInputRef = useRef(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [uomOption, setUomOption] = useState(null);
  const [partFamilyOption, setPartFamilyOption] = useState(null);
  const [orginOption, setOrginOption] = useState(null);
  const [statusOption, setStatusOption] = useState({
    value: true,
    label: "Active",
  });
  const [isLoader, setIsLoader] = useState(false);
  const [lengthValue, setLengthValue] = useState("");
  const [productValue, setProductValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [breadthValue, setBreadthValue] = useState("");
  const [heightValue, setHeightValue] = useState("");
  const [descriptValue, setDescriptValue] = useState("");
  const [selectedUnit, setSelectedUnit] = useState({
    label: "CM",
    value: "cm",
  });

  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "product",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/product");
    }
  };

  const vendorId = vendorFromNav?.vendorId;
  const vendorName = vendorFromNav?.vendorName;

  useEffect(() => {
    if (vendorId && vendorName) {
      setSelectedSupplierList([{ value: vendorId, label: vendorName }]);
    }
  }, [vendorId, vendorName]);

  const [errorMsg, setErrorMsg] = useState({
    code: "",
    name: "",
    uom: "",
    product_group_id: "",
    origin: "",
    lead_time: "",
    inspection_type: "",
    min_qty: "",
    width: "",
    length: "",
    height: "",
    dimension: "",
    status: "",
    description: "",
    suppliers: "",
    removed_suppliers: "",
  });

  const [selectedSupplierList, setSelectedSupplierList] = useState([]);
  const [removeSupplierList, setRemoveSupplierList] = useState([]);
  const [imageRemoved, setImageRemoved] = useState(false);
  const [dragging, setDragging] = useState(false);

  const handleInputFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAutoSupplierDropdownChange = (selectedOptions) => {
    const options = selectedOptions || [];
    const removed = selectedSupplierList.filter(
      (oldItem) => !options.some((newItem) => newItem.value === oldItem.value),
    );

    if (removed.length > 0) {
      setRemoveSupplierList((prev) => [...prev, ...removed]);
    }

    setSelectedSupplierList(options);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchOptionsAutoSupplier = useCallback((inputValue, callback) => {
    apiCall("get", `get_vendor?term=${inputValue || ""}`)
      .then((response) => {
        const list = response?.data?.suggestionlist || [];
        const options = list.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("API Error:", error);
        callback([]);
      });
  }, []);

  useEffect(() => {
    if (id != null) {
      getProductEdit(id);
    }
  }, [id]);

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        code: codeValue,
        name: productValue,
        uom: uomOption?.value ?? "",
        product_group_id: partFamilyOption?.value ?? "",
        origin: orginOption?.value ?? "",
        width: breadthValue,
        length: lengthValue,
        height: heightValue,
        dimension: selectedUnit?.value ?? "",
        status: statusOption?.value ?? "",
        suppliers: selectedSupplierList
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        removed_suppliers: removeSupplierList
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        description: descriptValue,
      };

      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "assignee"
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });

      let response = null;
      if (id == null) {
        response = await submitProductAPI(sanitizedData);
      } else {
        response = await updateProductAPI(id, sanitizedData);
      }

      if (response.status === 400) {
        const validationTemp = {
          code: "",
          name: "",
          uom: "",
          product_group_id: "",
          origin: "",
          lead_time: "",
          inspection_type: "",
          min_qty: "",
          width: "",
          length: "",
          height: "",
          dimension: "",
          status: "",
          description: "",
          suppliers: "",
          removed_suppliers: "",
        };
        Object.entries(response.data.error || {}).forEach(([key, value]) => {
          validationTemp[key] =
            Array.isArray(value) && value.length > 0 ? value[0] : value;
        });
        setErrorMsg(validationTemp);
        setSnackbarMessage(response.data.message || "Validation failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();

        if (image === null && imageRemoved === false) {
          handleBack();
        } else {
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };

  const getProductEdit = async (id) => {
    try {
      const response = await getProductEditApi(id);
      if (response.data.success === true) {
        const productDetail = response.data.product ?? {};
        setPartFamilyOption({
          label: productDetail.product_group_label ?? "",
          value: productDetail.product_group_value ?? "",
        });
        setUomOption({
          label: productDetail.uom_label ?? "",
          value: productDetail.uom_value ?? "",
        });
        setStatusOption({
          label: productDetail.status === true ? "Active" : "In-Active",
          value: productDetail.status ?? false,
        });
        setOrginOption({
          label: productDetail.origin_label ?? "",
          value: productDetail.origin_value ?? "",
        });

        setDescriptValue(productDetail.description ?? "");
        setProductValue(productDetail.name ?? "");
        setCodeValue(productDetail.code ?? "");
        setHeightValue(productDetail.height ?? "");
        setBreadthValue(productDetail.width ?? "");
        setLengthValue(productDetail.length ?? "");
        setSelectedSupplierList(productDetail.suppliers ?? []);
        setSelectedUnit({
          label: (productDetail.dimension ?? "").toUpperCase() || "CM",
          value: productDetail.dimension ?? "cm",
        });
        setImageUrl(productDetail.image ?? "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching product:", err);
    }
  };

  const saveAttachment = async (parentId) => {
    try {
      const data = {
        attachment: image != null ? image : imageRemoved === true ? "" : "",
      };
      const response = await saveAttachmentApi(parentId, data);
      if (response.data.success === true) {
        handleBack();
      }
    } catch (err) {
      console.error("Error saving attachment:", err);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 99999 }}
      >
        <Toast
          onClose={handleSnackbarClose}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarStatus ? "success" : "danger"}
        >
          <Toast.Body className="text-white">{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="d-flex">
        <Sidebar currentfile="Products" />
        <div className="rounded-4 flex-grow-1" style={{ minWidth: 0, overflowX: "hidden" }}>
          <Navbar pageTitle="Products" />
          <div style={{ backgroundColor: "#F5F8FA", minHeight: "calc(100vh - 60px)" }}>
            <div
              className="d-flex bg-white align-items-center justify-content-between p-3 border-bottom"
              style={{ height: "64px" }}
            >
              <div className="d-flex align-items-center gap-3">
                <MoveLeft size={20} className="cursor-pointer flex-shrink-0" onClick={handleBack} />
                <p className="m-0 fs-16 fw-600">
                  {id != null ? "Update product" : "New product"}
                </p>
              </div>
              <div className="d-flex gap-3">
                <button
                  onClick={handleBack}
                  className="rounded-pill px-4 py-1 bg-transparent fs-15 fw-500 textcolor"
                  style={{ border: "1px solid #D4DDE7", height: "40px" }}
                >
                  Cancel
                </button>
                <button
                  className="backgroundPrimary rounded-pill px-4 py-1 text-white border-0 fs-15 fw-500"
                  onClick={isLoader ? null : submitForm}
                  style={{ height: "40px", minWidth: "90px" }}
                >
                  {isLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : id != null ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>

            <div className="p-3">
              <div className="bg-white rounded-4 p-4 mb-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1 pe-4">
                    <p className="fs-16 fw-600 mb-3">Product details</p>
                    <div className="mb-3">
                      <label className="fs-14 fw-600 textltcolor mb-1">
                        Product Name<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Product Name"
                        value={productValue || ""}
                        onChange={(e) => setProductValue(e.target.value)}
                        className="form-control rounded-3 vendor-form-input"
                      />
                      {errorMsg.name && (
                        <span className="error-txt fs-12 fw-500 d-block mt-1">
                          {errorMsg.name}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-center">
                    {image ? (
                      <div
                        style={{
                          position: "relative",
                          width: "100px",
                          height: "100px",
                        }}
                        className="cursor-pointer"
                      >
                        <div
                          onClick={handleInputFile}
                          onDrop={handleDrop}
                          onDragOver={(e) => e.preventDefault()}
                          onDragEnter={() => setDragging(true)}
                          onDragLeave={() => setDragging(false)}
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={image}
                            className="rounded-circle"
                            alt="Uploaded Product"
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <button
                          onClick={() => setImage(null)}
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            background: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <X size={16} color="#ff0000" />
                        </button>
                      </div>
                    ) : imageUrl !== "" ? (
                      <div
                        style={{
                          position: "relative",
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={imageUrl}
                            className="rounded-circle"
                            alt="Uploaded Product"
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <button
                          onClick={() => {
                            setImageUrl("");
                            setImageRemoved(true);
                          }}
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            background: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <X size={16} color="#ff0000" />
                        </button>
                      </div>
                    ) : (
                      <div
                        className="d-flex cursor-pointer align-items-center justify-content-center rounded-4 p-4"
                        style={{
                          width: "116px",
                          height: "116px",
                          background: "#F6F5FF",
                        }}
                        onClick={handleInputFile}
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                        onDragEnter={() => setDragging(true)}
                        onDragLeave={() => setDragging(false)}
                      >
                        <img src={uploadImage} alt="Upload icon" style={{ width: "32px", height: "32px", objectFit: "contain" }} />
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      className="d-none"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                <p className="fs-14 fw-600 mt-4 mb-3">Basic Information</p>
                <div className="row align-items-center mb-3">
                  <div className="col-xl-2 col-md-3">
                    <label className="form-label fw-500 fs-13 m-0">
                      Code<span className="text-danger ms-1">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 col-md-3">
                    <input
                      type="text"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={codeValue || ""}
                      onChange={(e) => setCodeValue(e.target.value)}
                    />
                    {errorMsg.code && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.code}
                      </span>
                    )}
                  </div>

                  <div className="col-xl-2 col-md-3 mt-3 mt-md-0">
                    <label className="form-label fw-500 fs-13 m-0">
                      Origin
                    </label>
                  </div>
                  <div className="col-xl-4 col-md-3 mt-3 mt-md-0">
                    <CommonDropdown
                      apiUrl={`${adminUrl}get_country?term=`}
                      placeholder="Select"
                      className="w-100"
                      value={orginOption}
                      onSelect={(item) => setOrginOption(item)}
                    />
                    {errorMsg.origin && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.origin}
                      </span>
                    )}
                  </div>
                </div>

                <div className="row align-items-center mb-3">
                  <div className="col-xl-2 col-md-3">
                    <label className="form-label fw-500 fs-13 m-0">
                      UOM<span className="text-danger ms-1">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 col-md-3">
                    <CommonDropdown
                      apiUrl={`${apiUrl}get_uom?term=`}
                      placeholder="Select"
                      className="w-100"
                      value={uomOption}
                      onSelect={(item) => setUomOption(item)}
                    />
                    {errorMsg.uom && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.uom}
                      </span>
                    )}
                  </div>

                  <div className="col-xl-2 col-md-3 mt-3 mt-md-0">
                    <label className="form-label fw-500 fs-13 m-0">
                      Status
                    </label>
                  </div>
                  <div className="col-xl-4 col-md-3 mt-3 mt-md-0">
                    <CommonStaticDropdown
                      items={[
                        { value: true, label: "Active" },
                        { value: false, label: "In-Active" },
                      ]}
                      placeholder="Select"
                      value={statusOption}
                      enableSearch={false}
                      onSelect={(item) => setStatusOption(item)}
                    />
                    {errorMsg.status && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.status}
                      </span>
                    )}
                  </div>
                </div>

                <div className="row align-items-center">
                  <div className="col-xl-2 col-md-3">
                    <label className="form-label fw-500 fs-13 m-0">Group</label>
                  </div>
                  <div className="col-xl-4 col-md-3">
                    <CommonDropdown
                      apiUrl={`${apiUrl}get_product_group?term=`}
                      placeholder="Select"
                      className="w-100"
                      value={partFamilyOption}
                      onSelect={(item) => setPartFamilyOption(item)}
                    />
                    {errorMsg.product_group_id && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.product_group_id}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-4 p-4">
                <p className="fs-16 fw-600 mb-3">Other Information</p>

                <div className="row align-items-center mb-3">
                  <div className="col-xl-2 col-md-3">
                    <label className="form-label fw-500 fs-13 m-0">
                      Dimension
                    </label>
                  </div>
                  <div className="col-xl-10 col-md-9">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <div style={{ width: "90px" }}>
                        <input
                          type="number"
                          className="form-control rounded-3 vendor-form-input"
                          placeholder="L"
                          value={lengthValue || ""}
                          onChange={(e) => setLengthValue(e.target.value)}
                        />
                      </div>
                      <div style={{ width: "90px" }}>
                        <input
                          type="number"
                          className="form-control rounded-3 vendor-form-input"
                          placeholder="B"
                          value={breadthValue || ""}
                          onChange={(e) => setBreadthValue(e.target.value)}
                        />
                      </div>
                      <div style={{ width: "90px" }}>
                        <input
                          type="number"
                          className="form-control rounded-3 vendor-form-input"
                          placeholder="H"
                          value={heightValue || ""}
                          onChange={(e) => setHeightValue(e.target.value)}
                        />
                      </div>
                      <div>
                        <Dropdown>
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="text-black border-0 px-3 py-2"
                            style={{ backgroundColor: "#F8F8F8" }}
                          >
                            {selectedUnit?.label || ""}{" "}
                            <img src={dropDown} alt="dropdown" />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {selectUnitOption.map((option) => (
                              <Dropdown.Item
                                key={option.value}
                                onClick={() => setSelectedUnit(option)}
                              >
                                {option.label}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    {(errorMsg.width || errorMsg.length || errorMsg.height) && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.width || errorMsg.length || errorMsg.height}
                      </span>
                    )}
                  </div>
                </div>

                <div className="row align-items-center mb-3">
                  <div className="col-xl-2 col-md-3">
                    <label className="form-label fw-500 fs-13 m-0">
                      Suppliers
                    </label>
                  </div>
                  <div className="col-xl-10 col-md-9">
                    <AsyncSelect
                      isMulti
                      cacheOptions
                      value={selectedSupplierList}
                      loadOptions={fetchOptionsAutoSupplier}
                      onChange={handleAutoSupplierDropdownChange}
                      defaultOptions
                      placeholder="Search supplier..."
                      styles={multiselectCustomStyles}
                      isClearable={false}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                    />
                    {errorMsg.suppliers && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.suppliers}
                      </span>
                    )}
                  </div>
                </div>

                <div className="row align-items-start">
                  <div className="col-xl-2 col-md-3 mt-2">
                    <label className="form-label fw-500 fs-13 m-0">
                      Description
                    </label>
                  </div>
                  <div className="col-xl-10 col-md-9">
                    <textarea
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter description here..."
                      rows={3}
                      value={descriptValue || ""}
                      onChange={(e) => setDescriptValue(e.target.value)}
                    ></textarea>
                    {errorMsg.description && (
                      <span className="error-txt fs-12 fw-500 d-block mt-1">
                        {errorMsg.description}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
